import { Router } from '@lightningjs/sdk'

import Button from '../../../components/button/button'
import { getColor, grey50, transparent } from '../../../constants/colors'
import { UniNeueBold, UniNeueHeavy } from '../../../constants/fonts'
import { LEFT_SAFE_ZONE_MARGIN } from '../../../constants/general'
import { getText } from '../../../utils/dictionary'
import { captureScreenData, NON_BFF_SEGMENT_SCREENS } from '../../../utils/segmentAnalytics'
import PageHandler from '../../handlers/pageHandler'

export default class PrivacyPolicy extends PageHandler {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: transparent,
      flex: {
        direction: 'column',
        paddingLeft: LEFT_SAFE_ZONE_MARGIN,
        paddingTop: 48,
      },
      Title: {
        text: {
          text: getText('privacyPolicy'),
          fontSize: 64,
          fontFace: UniNeueHeavy,
          textColor: getColor(grey50),
          lineHeight: 72,
        },
      },
      Description: {
        flexItem: { marginTop: 40 },
        text: {
          text: getText('privacyPolicyUrl'),
          fontSize: 32,
          fontFace: UniNeueBold,
          textColor: getColor(grey50),
          lineHeight: 36,
        },
      },
      Button: {
        w: 240,
        type: Button,
        icon: 'icon-back-arrow',
        label: getText('goBackButton'),
        flexItem: { marginTop: 40 },
      },
    }
  }

  get button() {
    return this.tag('Button') as Button
  }

  get pageText(): string {
    return getText('privacyPolicy')
  }

  get sectionText(): string {
    return getText('privacyPolicyUrl')
  }

  _active() {
    void captureScreenData(NON_BFF_SEGMENT_SCREENS.Settings, NON_BFF_SEGMENT_SCREENS.PrivacyPolicy)
  }

  _getFocused() {
    return this.button
  }

  _handleEnter() {
    Router.back()
  }

  _handleLeft() {
    Router.focusWidget('Menu')
  }

  _handleClick() {
    this._handleEnter()
  }
  _onCursorLeave() {
    this.button?._focus()
  }
}
